module.exports = __webpack_public_path__ + "static/nestted-b560d26106a2127f35402a9d63c66b60.svg";